import { createBrowserClient } from '@supabase/ssr';

import { getCookieDomainForHostname } from '@/lib/supabase/cookieDomain';
import { ClientType, SassClient } from '@/lib/supabase/unified';
import { Database } from '@/lib/types';

const getCookieDomain = () => {
  if (typeof window === 'undefined') {
    return undefined;
  }
  return getCookieDomainForHostname(window.location.hostname);
};

export function createSPAClient() {
  return createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      cookieOptions: {
        domain: getCookieDomain(),
        path: '/',
        sameSite: 'lax',
        secure: process.env.NODE_ENV === 'production',
      },
    },
  );
}

export async function createSPASassClient() {
  const client = createSPAClient();
  return new SassClient(client, ClientType.SPA);
}
